{
  "version": 1,
  "asset_id": "f99015fd-d133-4573-b8c6-c6a474d2436f",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/f99015fd-d133-4573-b8c6-c6a474d2436f/trustly.svg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/f99015fd-d133-4573-b8c6-c6a474d2436f/trustly.svg",
  "original_filename": "trustly.svg",
  "size": 3655,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-30T15:11:24Z"
}
